import { SxProps, Theme } from '@mui/material';

export const styles: Record<'removeButton', SxProps<Theme>> = {
  removeButton: {
    background: '#ffffff',
    justifyContent: 'flex-start',
  },
};
